// Displayed prices verified against the existing live Stripe catalog.
// This module does not change checkout prices or usage enforcement.
export const STUDY_OFFERS = {
  exam_week: { amount: 4.99, currency: "EUR", trialDays: 0 },
  monthly: { amount: 6.99, currency: "EUR", trialDays: 7 },
  annual: { amount: 49.99, currency: "EUR", trialDays: 7 },
} as const;

export type StudyPlan = keyof typeof STUDY_OFFERS;

export function formatOfferPrice(plan: StudyPlan, locale: string) {
  const offer = STUDY_OFFERS[plan];
  return new Intl.NumberFormat(locale, { style: "currency", currency: offer.currency }).format(offer.amount);
}

export function studyOfferSchema() {
  return [
    { "@type": "Offer", name: "Free", price: "0", priceCurrency: "EUR", description: "Free account: 2 revision sheets and 5 AI actions per day." },
    ...Object.entries(STUDY_OFFERS).map(([plan, offer]) => ({
      "@type": "Offer",
      name: plan === "exam_week" ? "Exam Week" : plan === "monthly" ? "Pro Monthly" : "Pro Annual",
      price: offer.amount.toFixed(2),
      priceCurrency: offer.currency,
      url: "https://systematlas.fr/pricing",
      description: plan === "exam_week"
        ? "One-time payment for 7 days of Pro access. No automatic renewal or free trial."
        : `${plan === "monthly" ? "Monthly" : "Annual"} subscription with a 7-day free trial. Payment method required. Automatically billed after the trial unless cancelled.`,
    })),
  ];
}